// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2e7Nq","checkmark":"checkmark-3gbUL"};